import { render, staticRenderFns } from "./EpisodeHot.vue?vue&type=template&id=652d4fe8&scoped=true&"
import script from "./EpisodeHot.vue?vue&type=script&lang=js&"
export * from "./EpisodeHot.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeHot.vue?vue&type=style&index=0&id=652d4fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d4fe8",
  null
  
)

export default component.exports